import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  Button,
  FormLabel,
  Typography,
  Container,
  Paper,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import UserAndDate from "src/components/common/UserAndDate";
import parse from "html-react-parser";

const mailingStatuses = {
  draft: "Wersja robocza",
  pending: "Oczekiwanie na wysyłkę",
  sending: "Wysyłanie",
  sent: "Wysłane",
  partially_sent: "Częściowo wysłane",
  error: "Błąd",
};

const useStyles = makeStyles((theme) => ({
  root: {},
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(2),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  paddingpaper: {
    padding: theme.spacing(1),
    "& > ol, & > ul": {
      marginLeft: theme.spacing(4),
    },
  },
  paddingtopbottom: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  margintop: {
    marginTop: theme.spacing(1),
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const recipientsCols = [
  {
    id: "lp",
    label: "L.p.",
    lp: true,
    isEditable: false,
    sortable: false,
    width: "3%",
  },
  {
    id: "username",
    label: "Nazwa użytkownika",
    fieldName: "username",
    isEditable: false,
    sortable: true,
    width: "9%",
  },
  {
    id: "userFirstName",
    label: "Imię",
    fieldName: "userFirstName",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
  {
    id: "userLastName",
    label: "Nazwisko",
    fieldName: "userLastName",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
  {
    id: "userInstitution",
    label: "Instytucja",
    fieldName: "userInstitution",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
  {
    id: "userFunction",
    label: "Funkcja",
    fieldName: "userFunction",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
  {
    id: "status",
    label: "Status wysyłki",
    fieldName: "status",
    isEditable: false,
    sortable: true,
    dataType: 2,
    dataLabels: {
      draft: "Wersja robocza",
      pending: "Oczekiwanie na wysyłkę",
      sending: "Wysyłanie",
      sent: "Wysłane",
      error: "Błąd",
    },
    width: "10%",
  },
  {
    id: "recipientemail",
    label: "Adres email",
    fieldName: "recipientEmail",
    isEditable: false,
    sortable: true,
    width: "10%",
  },

  {
    id: "sentAt",
    label: "Data wysyłki",
    fieldName: "sentAt",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
];

const Form = ({ mailing, ...rest }) => {
  const classes = useStyles();
  const [tabNo, setTabNo] = useState(0);

  useEffect(() => {
    return () => {};
  }, [mailing]);

  const handleTabChange = (event, newValue) => {
    setTabNo(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Card className={clsx(classes.root)} {...rest}>
      <Container component="main" maxWidth={false}>
        <Grid container className={classes.paddingtop}>
          <Grid item xs={12} elevation={2}>
            <AppBar position="static">
              <Tabs
                value={tabNo}
                onChange={handleTabChange}
                aria-label="Powiadomienie"
              >
                <Tab label="Szczegóły" {...a11yProps(0)} />
                <Tab label="Podgląd treści" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <TabPanel value={tabNo} index={0} className={classes.editroot}>
              {mailing ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Rodzaj wiadomości
                  </FormLabel>
                  <Typography>{mailing.messageTypeName}</Typography>
                </FormControl>
              ) : (
                <Skeleton />
              )}

              {mailing ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Temat
                  </FormLabel>
                  <Typography>{mailing.subject}</Typography>
                </FormControl>
              ) : (
                <Skeleton />
              )}

              {mailing ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sm={4}>
                      <FormControl fullWidth className={classes.formcontrol}>
                        <FormLabel
                          className={classes.paddingBottom}
                          component="label"
                        >
                          Status
                        </FormLabel>
                        <Typography>
                          {mailingStatuses[mailing.status]}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} sm={4}>
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Kto i kiedy utworzył
                      </FormLabel>
                      <UserAndDate
                        variant="body1"
                        username={mailing.createdBy}
                        date={mailing.createdAt}
                        separator=", "
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} sm={4}>
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Kto i kiedy modyfikował
                      </FormLabel>
                      <UserAndDate
                        variant="body1"
                        username={mailing.updatedBy}
                        date={mailing.updatedAt}
                        separator=", "
                      />
                    </Grid>
                  </Grid>
                </FormControl>
              ) : (
                <Skeleton />
              )}

              {mailing ? (
                <Box className={classes.paddingtopbottom}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Adresaci
                  </FormLabel>
                  <KmFilteredTable
                    className={classes.paddingtop}
                    markable={false}
                    headCells={recipientsCols}
                    rows={mailing.recipients}
                  />
                </Box>
              ) : (
                <Skeleton />
              )}
            </TabPanel>
            <TabPanel value={tabNo} index={1} className={classes.editroot}>
              {mailing ? (
                <Paper className={classes.paddingpaper}>
                  {parse(mailing.body)}
                </Paper>
              ) : (
                "-"
              )}
            </TabPanel>

            <Box className={classes.paddingtopbottom}>
              <Button
                color="primary"
                className={classes.button}
                component={RouterLink}
                to={`/powiadomienia`}
              >
                Zamknij
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Card>
  );
};

export default Form;
